/**
 * Workflows P5-6 (DEC-098): the article card (`show_article`) and the AI summary note (`add_summary_note`).
 * Mirrors backend `app/core/constants/workflow_content.py`; the step lists live in `workflows.ts` next to the others.
 */

/** The longest text and button label of an article card; Messenger cuts the button title to its own limit. */
export const ARTICLE_LIMITS = { textMax: 500, labelMax: 40, messengerLabelMax: 20 } as const;
/** What the card's button says when the step has no label (server copy; translatable per workflow like any button). */
export const ARTICLE_DEFAULT_LABEL = { en: "Open article", fil: "Buksan ang artikulo" } as const;
/** The wire `kind` of an article card (`workflow_step` payload). */
export const ARTICLE_CARD_KIND = "article";
/** Why a `show_article` step showed nothing and the run went on (the run log's `detail.reason`). */
export const ARTICLE_SKIP_REASONS = ["audience", "source_unavailable"] as const;
export type ArticleSkipReason = (typeof ARTICLE_SKIP_REASONS)[number];
/** The most pages the page picker lists for one crawled website. */
export const ARTICLE_PAGES_MAX = 50;

/** One AI credit per note, written once per run and step; Pro and up. */
export const SUMMARY_NOTE_CREDITS = 1;
/** A conversation shorter than this is skipped (nothing to summarise). */
export const SUMMARY_NOTE_MIN_MESSAGES = 4;
/** The most recent turns the summary reads, and the most it writes. */
export const SUMMARY_NOTE_TURNS = 30;
export const SUMMARY_NOTE_MAX_CHARS = 1200;
/** Why an `add_summary_note` step wrote nothing and the run went on. */
export const SUMMARY_SKIP_REASONS = ["too_short", "summary_rate_limited", "no_credits", "no_conversation", "plan", "summary_unavailable", "already_done", "preview"] as const;
export type SummarySkipReason = (typeof SUMMARY_SKIP_REASONS)[number];
